const uri = {
    SIGN_IN: 'signin',
    SIGN_OUT: 'signout',
    UPDATE_PASS: 'partner-update-password',
    UPDATE_PASS_PUBLIC: 'partner-public-update-password',
    FORGOT_PASS: 'partner-forget-password',
    CHECK_OTP: 'partner-check-otp',
    PO_LIST: 'purchase-order',
    PO_DETAIL: 'purchase-detail',
    PO_LINES: 'purchase-lines',
    RFQ_LIST: 'rfq-order',
    RFQ_DETAIL: 'rfq-detail',
    RFQ_UPDATE: 'update-rfq-order',
    BILL_LIST: 'vendor-bills',
    BILL_LINES: 'vendor-bill-lines',
    BILL_PAYMENT: 'vendor-bill-payment',
    CERTIFICATE_LIST: 'certificate-list',
    CERTIFICATE_DETAIL: 'certificate-detail',
    CERTIFICATE_UPSERT: 'certificate-upsert',
    CERTIFICATE_COMPARE_EFAKTUR_DN: 'certificate-compare-efaktur-dn',
    CERTIFICATE_VALIDATE: 'certificate-validate',
    CERTIFICATE_CANCEL: 'certificate-cancel',
    CERTIFICATE_DRAFT: 'certificate-draft',
    DN_LIST: 'delivery-notes-list',
    DN_DETAIL: 'delivery-notes-detail',
    PARTNER_PROFILE: 'partner-profile',
    PARTNER_PROFILE_UPDATE: 'partner-profile-update',
    PROVINCE: 'get-province',
    COUNTRY: 'get-country',
    SERVICE_TYPE: 'get-service-type',
    FORECAST_LIST: 'vendor-forecast-list',
    FORECAST_DETAIL: 'vendor-forecast-detail',
    EVALUATION_LIST: 'vendor-evaluation-list',
    EVALUATION_DETAIL: 'vendor-evaluation-detail',
    QPR_LIST: 'qpr-list',
    QPR_DETAIL: 'qpr-detail',
    QPR_CONFIRM: 'qpr-confirm',
    TENDER_LIST: 'vendor-tender',
    TENDER_LINES: 'vendor-tender-line',
    TENDER_DOCUMENT: 'vendor-tender-document',
    TENDER_DETAIL: 'vendor-tender-detail',
    TENDER_SUBMIT: 'create-vendor-bidding',
    BIDDING_LIST: 'vendor-bidding',
    BIDDING_LINES: 'vendor-bidding-line',
    BIDDING_UPDATE: 'update-vendor-bidding',
    BIDDING_DOCUMENT: 'vendor-bidding-document',
    BIDDING_HISTORY: 'vendor-bidding-price-history',
    DELIVERY_LIST: 'daily-delivery-list',
    DELIVERY_DETAIL: 'daily-delivery-detail',
    DOWNLOAD: 'download-printout',
    UPLOAD_DOCUMENT: 'partner-upload-document',
    DOWNLOAD_DOCUMENT: 'partner-download-document',
    GET_PO_FROM_DN: 'certificate-get-po-from-dn',
    GET_ATTACHMENT_BINARY: 'get-attachment-binary',
    DASHBOARD_PURCHASE: 'dashboard-purchase-order',
    DASHBOARD_BILL: 'dashboard-vendor-bills',
    DASHBOARD_TENDER: 'dashboard-vendor-tender',
}
  
module.exports = uri